// Multivariate Dependencies
import React from 'react';
// Components
import { IconButton } from '../../../atoms/IconButton';
import { PopupMechanism } from '../../../common/components/PopupMechanism';
import { DropdownList } from '../../DropdownList';
import { LineItem } from '../../LineItem';
// Hooks
import { useDropdownVisibility } from '../../ButtonWithDropdown/hooks/useDropdownVisibility';
export var IconButtonWithDropdown = function (_a) {
    var className = _a.className, styleVariant = _a.styleVariant, size = _a.size, options = _a.options, icon = _a.icon, ariaLabel = _a.ariaLabel, _b = _a.alignment, alignment = _b === void 0 ? 'center' : _b, _c = _a.disabled, disabled = _c === void 0 ? false : _c, dropdownWidth = _a.dropdownWidth, onClick = _a.onClick;
    var _d = useDropdownVisibility(), buttonRef = _d.buttonRef, dropdownListRef = _d.dropdownListRef, setDropdownVisibility = _d.setDropdownVisibility, isDropdownVisible = _d.isDropdownVisible;
    return (React.createElement(React.Fragment, null,
        React.createElement(IconButton, { className: className, ref: buttonRef, styleVariant: styleVariant, disabled: disabled, size: size, ariaLabel: ariaLabel, onClick: function (e) {
                if (onClick) {
                    onClick(e);
                }
                setDropdownVisibility(!isDropdownVisible);
            }, icon: icon !== null && icon !== void 0 ? icon : 'CaretDown' }),
        isDropdownVisible ? (React.createElement(PopupMechanism, { targetedElement: buttonRef, placement: 'bottom', alignToTargetedElement: alignment, spaceBetweenElement: 8 },
            React.createElement(DropdownList, { ref: dropdownListRef, role: 'list', width: dropdownWidth }, options.map(function (_a) {
                var id = _a.id, optionIcon = _a.icon, state = _a.state, onClickOption = _a.onClick, optionLabel = _a.label, subtitle = _a.subtitle;
                return (React.createElement(LineItem, { key: id, leftIcon: optionIcon, subtitle: subtitle, state: state, onClick: function (e) {
                        e.preventDefault();
                        if (onClickOption) {
                            onClickOption(e);
                        }
                        setDropdownVisibility(false);
                    } }, optionLabel));
            })))) : null));
};
//# sourceMappingURL=IconButtonWithDropdown.js.map